import { render, staticRenderFns } from "./OfertasTitulo.vue?vue&type=template&id=2b703171"
import script from "./OfertasTitulo.vue?vue&type=script&lang=js"
export * from "./OfertasTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b703171')) {
      api.createRecord('2b703171', component.options)
    } else {
      api.reload('2b703171', component.options)
    }
    module.hot.accept("./OfertasTitulo.vue?vue&type=template&id=2b703171", function () {
      api.rerender('2b703171', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OfertasTitulo.vue"
export default component.exports